<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Database Marketing Campaigns Report
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Campaigns</li>
        <li class="active">Campaigns Report</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Campaign List</h3>
              <div class="filter-container pull-right">
                  <div class="margin-lr-20px" style="flex:0.1">                  
                    <label for="date-from">Campaign Start Date</label>
                    <div class="input-group">
                        <input type="date" v-model="fromDt" id="date-from" class="form-control" placeholder="From" />
                        <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('fromDt')"></i></span>
                    </div>
                  </div>
                  <div class="margin-lr-20px" style="flex:0.1">
                    <label for="date-to">Campaign End Date</label>
                    <div class="input-group">
                      <input type="date" v-model="toDt" id="date-to" class="form-control" placeholder="To" />
                      <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('toDt')"></i></span>
                    </div>
                  </div>
                  <div class="margin-lr-20px" style="flex:0.2">
                    <label for="countries">Countries</label>
                    <treeselect
                      placeholder="--Choose countries--" 
                      :multiple="true" 
                      :options="countryOptions" 
                      style="min-width:200px;"
                      v-model="countries" />
                  </div>
                  <div class="search-opportunity" style="flex:0.2">
                    <label for="search">Campaign</label>
                    <div>
                      <input type="text" placeholder="Type campaign name and press 'Enter'"
                        v-reset-input='' v-on:keyup="listenEnterPress" class="form-control searchBox" 
                        v-model="searchOpportunity"/>
                    </div>      
                  </div>
                  <div class="margin-ltr-20px">
                    <i class="fa fa-2x fa-search" @click="getAllOpportunities" aria-hidden="true"></i>
                  </div>
                  <div class="margin-ltr-20px" style="flex:0.1">
                    <router-link class="btn btn-primary" :to="`/opportunity`">Create Campaign</router-link>
                  </div>
              </div>
            </div>
            <div class="box-body">
              <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" class="active"><a href="#is" aria-controls="is" role="tab" data-toggle="tab" @click="setActiveTab('is')">In-Session Campaigns</a></li>
                <li role="presentation"><a href="#oos" aria-controls="oos" role="tab" data-toggle="tab" @click="setActiveTab('oos')">Out-of-Session Campaigns</a></li>
              </ul>
               <div class="tab-content">
                <div role="tabpanel"  class="tab-pane active" id="is">
                  <!-- <div v-if="loading" class="empty-report">
                      <span>Fetching data...</span>
                  </div> -->
                  <div v-if="!loading && inSessionCampaignsList.length === 0" class="empty-report">
                    <span>Sorry, no reporting data for the current search config. If loading for the first time, please add search parameters</span>
                  </div>
                  <div v-else>
                    <div class="export-container">
                      <div>
                        <label> Toggle Column Groups Visibility</label>
                        <div  class="column-groups-container">
                          <div v-for="(value, key, index) in visibleColumnsIS" :key="key" class="column-group" :style="index === 0 ? 'margin-left:0px':'margin-left:5px'">
                            <span>{{key}}</span>
                            <label class="switch">
                              <input type="checkbox" v-model="visibleColumnsIS[key]" @change="handleColumnVisibilityToggle">
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary" @click="exportCSV">Export to CSV</button>
                    </div>
                    <div class="table-container">
                      <vue-good-table data-nv-no-remember
                        ref='dbm-is-table'
                        styleClass="vgt-table good-table condensed bordered"
                        mode="remote"
                        :columns="inSessionCampaignColumns"
                        :rows="inSessionCampaignsList"
                        @on-page-change="onPageChangeForISDbMCampaigns"
                        @on-sort-change="onSortChangeForISDbMCampaigns"
                        @on-per-page-change="onPerPageChangeForISDbMCampaigns"
                        :pagination-options="{
                          enabled: true,
                        }"
                        :group-options="{
                          enabled: true,
                          collapsable: true,
                          row_key: 'group_id'
                        }"
                        :sort-options="{
                          enabled: false
                        }"
                        :totalRows="inSessionCampaignsCount"
                      >
                        <div slot="emptystate"><nv-empty-state icon="fa-bar-chart" title="No campaigns in this period" hint="Try a different date range." /></div>
                        <template slot="loadingContent">
                        </template>
                        <template slot="table-header-row" slot-scope="props">
                          <slot :props="props" />
                          <span v-if="props.column.field == 'start_date' || props.column.field == 'end_date'">
                            {{ formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                          </span>
                          <span v-else-if="props.column.field == 'recurrence'">{{ toTitleCase(props.formattedRow[props.column.field]) }}</span>
                          <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        </template>
                        <template slot="table-column" slot-scope="props">
                          <span v-if="props.column.label === 'Response %'"> {{ props.column.label }}
                          <span title="Shows the % of users who responded with the option numbers shown in the initial message"><i class="fa fa-info-circle margin-10"></i></span>
                          </span>
                        </template> 
                      </vue-good-table>
                    </div>
                  </div>
                </div>
                <div role="tabpanel" class="tab-pane" id="oos">
                  <!-- <div v-if="loading" class="empty-report">
                      <span>Fetching data...</span>
                  </div> -->
                  <div v-if="!loading && outOfSessionCampaignsList.length === 0" class="empty-report">
                    <span>Sorry, no reporting data for the current search config. If loading for the first time, please add search parameters</span>
                  </div>
                  <div v-else>
                    <div class="export-container">
                      <div>
                        <label> Toggle Column Groups Visibility</label>
                        <div  class="column-groups-container">
                          <div v-for="(value, key, index) in visibleColumnsOOS" :key="key" class="column-group" :style="index === 0 ? 'margin-left:0px':'margin-left:5px'">
                            <span>{{key}}</span>
                            <label class="switch">
                              <input type="checkbox" v-model="visibleColumnsOOS[key]" @change="handleColumnVisibilityToggle">
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary" @click="exportCSV">Export to CSV</button>
                    </div>
                    <div class="table-container">
                      <vue-good-table data-nv-no-remember
                        ref='dbm-oos-table'
                        mode="remote"
                        styleClass="vgt-table good-table condensed bordered"
                        :columns="outOfSessionCampaignColumns"
                        :rows="outOfSessionCampaignsList"
                        @on-page-change="onPageChangeForOOSDbMCampaigns"
                        @on-sort-change="onSortChangeForOOSDbMCampaigns"
                        @on-per-page-change="onPerPageChangeForOOSDbMCampaigns"
                        :pagination-options="{
                          enabled: true,
                        }"
                        :group-options="{
                          enabled: true,
                          collapsable: true,
                          row_key: 'group_id'
                        }"
                        :sort-options="{
                          enabled: false
                        }"
                        :totalRows="outOfSessionCampaignsCount"
                      >
                        <div slot="emptystate"><nv-empty-state icon="fa-bar-chart" title="No campaigns in this period" hint="Try a different date range." /></div>
                        <template slot="loadingContent">
                        </template>
                        <template slot="table-header-row" slot-scope="props">
                          <slot :props="props" />
                          <span v-if="props.column.field == 'start_date' || props.column.field == 'end_date'">
                            {{ formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                          </span>
                          <span v-else-if="props.column.field == 'recurrence'">{{ toTitleCase(props.formattedRow[props.column.field]) }}</span>
                          <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        </template>    
                        <template slot="table-column" slot-scope="props">
                          <span v-if="props.column.label === 'Response %'"> {{ props.column.label }}
                          <span title="Shows the % of users who responded with the option numbers shown in the initial message"><i class="fa fa-info-circle margin-10"></i></span>
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>    
</template>
<script>
import api from '../../../utils/api'
import { formatDate, downloadCSVCustomColumns, getActiveCountryList } from '../../../utils/utilities'
import { instanceCountriesMapping } from '../../../config/constants'

var formatCost = (value) => {
  return value !== -2 ? (value === -1 ? 'NA' : `$${Number(value).toFixed(2)}`) : ''
}
const startBaseInfoColumns = [
  {
    label: 'Country',
    field: 'country_name'
  },
  {
    label: 'Name',
    field: 'opportunity_name'
  },
  {
    label: 'Start Date',
    field: 'start_date'
  },
  {
    label: 'Customer',
    field: 'customer_name'
  },
  {
    label: 'Status',
    field: 'status'
  }
]
const endBaseInfoColumns = [
  {
    label: 'End Date',
    field: 'end_date'
  },
  {
    label: 'Type',
    field: 'recurrence'
  },
  {
    label: 'Audience / Journey',
    field: 'campaign_type'
  }
]
const referralColumns = [
  {
    label: 'Referral Carts',
    field: 'referral_carts'
  },
  {
    label: 'Referrals',
    field: 'referrals'
  },
  {
    label: 'Referral %',
    field: 'referral_percent'
  },
  {
    label: 'Redemption Intent',
    field: 'redemption_intent'
  },
  {
    label: 'Redemption Intent %',
    field: 'redemption_intent_percent'
  },
  {
    label: 'Redemptions',
    field: 'redemptions'
  },
  {
    label: 'Redemptions %',
    field: 'redemptions_percent'
  }
]
const thresholdColumns = [
  {
    label: 'Threshold',
    field: 'threshold_name'
  },
  {
    label: 'Threshold %',
    field: 'threshold_percent'
  }
]
const responseColumns = [
  {
    label: 'Response %',
    field: 'response_percent'
  },
  {
    label: 'Responded to Options',
    field: 'responded_to_options'
  }
]
const groupsSplitColumns = [
  {
    label: 'Groups',
    field: 'group_name'
  },
  {
    label: 'Split %',
    field: 'split_percent'
  }
]
const costColumns = [
  {
    label: 'Cost',
    field: 'price',
    formatFn: formatCost
  },
  {
    label: 'Cost Per Referral',
    field: 'price_per_referral',
    formatFn: formatCost
  },
  {
    label: 'Cost Per Redemption',
    field: 'price_per_redemption',
    formatFn: formatCost
  }
]
const pokesColumns = [
  {
    label: 'pOkEs sent',
    field: 'pokes_sent'
  },
  {
    label: 'Unique users pOkEd',
    field: 'unique_users_poked'
  },
  {
    label: 'Responses to pOkEs',
    field: 'responses_to_pokes'
  },
  {
    label: 'Random response from user',
    field: 'responses_to_pokes_without_1'
  }
]
const nudgeColumns = [
  {
    label: 'Nudge Template',
    field: 'msg_template_name'
  },
  {
    label: 'Nudges sent',
    field: 'pokes_sent'
  },
  {
    label: 'Responded to nudge',
    field: 'responses_to_pokes'
  },
  {
    label: 'Random response from user',
    field: 'responses_to_pokes_without_1'
  },
  {
    label: 'Distinct users nudged',
    field: 'unique_users_poked'
  }
]
const goalColumns = [
  {
    label: 'Goal',
    field: 'goal'
  },
  {
    label: 'Goal Achieved',
    field: 'goal_achieved'
  }
]
const initialISQuery = {
  limit: 10,
  page: 1,
  sort: {
    'o.opportunity_name': 'asc'
  },
  oeType: true
}
const initialOOSQuery = {
  limit: 10,
  page: 1,
  sort: {
    'o.opportunity_name': 'asc'
  },
  oeType: false
}
export default {
  name: 'dbmMarketingReport',
  async mounted () {
    this.inSessionCampaignColumns = this.generateInSessionCampaignColumns()
    this.outOfSessionCampaignColumns = this.generateOutOfSessionCampaignColumns()
    this.countryOptions = await getActiveCountryList('obj')
  },
  data () {
    return {
      countryOptions: [],
      countries: [],
      formatDate: formatDate,
      opportunitySearchResult: [],
      searchOpportunity: '',
      searchCountries: [],
      loading: false,
      inSessionCampaignsList: [],
      outOfSessionCampaignsList: [],
      fromDt: '',
      toDt: '',
      inSessionCampaignColumns: [],
      outOfSessionCampaignColumns: [],
      visibleColumnsIS: {
        'Referral Column Group': true
      },
      visibleColumnsOOS: {
        'Referral Column Group': true,
        'Cost Column Group': true
      },
      activeTab: 'is',
      isTableQueryParam: {...initialISQuery},
      oosTableQueryParam: {...initialOOSQuery},
      outOfSessionCampaignsCount: 0,
      inSessionCampaignsCount: 0
    }
  },
  methods: {
    toTitleCase (str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1, str.length).toLowerCase()
    },
    setActiveTab (tab) {
      this.activeTab = tab
    },
    clearDate (dateName) {
      if (dateName === 'fromDt') {
        this.fromDt = ''
      }
      if (dateName === 'toDt') {
        this.toDt = ''
      }
    },
    getEmptyObject (keys) {
      const obj = {}
      for (let objKey of keys) {
        obj[objKey] = ''
      }
      return obj
    },
    listenEnterPress (event) {
      if (event.key === 'Enter' || event.keyCode === 13) this.getAllOpportunities()
    },
    filterDates (campaignsList, fromDt, toDt) {
      if (fromDt && toDt) {
        console.log('filterDates::fromDt', fromDt, ' toDt ', toDt)
        return campaignsList.filter(ele => ele.start_date && new Date(ele.start_date).getTime() >= new Date(fromDt).getTime() &&
                                           ele.end_date && new Date(ele.end_date).getTime() <= new Date(toDt).getTime())
      } else if (fromDt) {
        return campaignsList.filter(ele => ele.start_date && new Date(ele.start_date).getTime() >= new Date(fromDt).getTime())
      } else if (toDt) {
        return campaignsList.filter(ele => ele.end_date && new Date(ele.end_date).getTime() <= new Date(toDt).getTime())
      }
      return campaignsList
    },
    filterCountries (campaignsList, countries) {
      if (countries.length > 0) {
        return campaignsList.filter(ele => countries.includes(ele.country_name.toLowerCase()))
      }
      return campaignsList
    },
    filterSearchText (campaignsList, searchText) {
      if (searchText.length > 0) {
        return campaignsList.filter(ele => ele.opportunity_name.toLowerCase().includes(searchText.toLowerCase()))
      }
      return campaignsList
    },
    updateParamsForISDbMCampaigns (newProps) {
      this.isTableQueryParam = {...this.isTableQueryParam, ...newProps}
    },
    onPageChangeForISDbMCampaigns (params) {
      this.updateParamsForISDbMCampaigns({page: params.currentPage})
      this.getOpportunities('is')
    },
    onPerPageChangeForISDbMCampaigns (params) {
      this.updateParamsForISDbMCampaigns({limit: 10})
      this.getOpportunities('is')
    },
    onSortChangeForISDbMCampaigns (params) {
      this.updateParamsForISDbMCampaigns({
        sort: {
          [this.inSessionCampaignColumns[params.columnIndex].field]: params.sortType
        }
      })
      this.getOpportunities('is')
    },
    updateParamsForOOSDbMCampaigns (newProps) {
      this.oosTableQueryParam = {...this.oosTableQueryParam, ...newProps}
    },
    onPageChangeForOOSDbMCampaigns (params) {
      this.updateParamsForOOSDbMCampaigns({page: params.currentPage})
      this.getOpportunities('oos')
    },
    onPerPageChangeForOOSDbMCampaigns (params) {
      this.updateParamsForOOSDbMCampaigns({limit: 10})
      this.getOpportunities('oos')
    },
    onSortChangeForOOSDbMCampaigns (params) {
      this.updateParamsForOOSDbMCampaigns({
        sort: {
          [this.outOfSessionCampaignColumns[params.columnIndex].field]: params.sortType
        }
      })
      this.getOpportunities('oos')
    },
    async getAllOpportunities () {
      this.loading = true
      if ((Date.parse(this.toDt) < Date.parse(this.fromDt))) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: 'End date should be greater than Start date'
        })
        return false
      }
      if (!(this.searchOpportunity.length || this.toDt.length || this.fromDt.length || this.countries.length)) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: 'Please enter at least one search parameter'
        })
        return false
      }

      if (this.$refs['dbm-is-table']) this.$refs['dbm-is-table'].reset()
      if (this.$refs['dbm-oos-table']) this.$refs['dbm-oos-table'].reset()
      await this.getOpportunities('is', true)
      await this.getOpportunities('oos', true)
      this.loading = false
    },
    async getOpportunities (campaignType, resetLimitOffset = false) {
      this.loading = true
      let { startTime, endTime } = this.getStartAndEndTimes()
      let queryParams = this.generateQueryParams(startTime, endTime, campaignType, true, resetLimitOffset)
      return this.getDbMReport(queryParams, campaignType)
    },
    getStartAndEndTimes () {
      let startTime = ''
      if (this.fromDt) {
        startTime = Date.UTC(this.fromDt.split('-')[0], this.fromDt.split('-')[1] - 1, this.fromDt.split('-')[2])
        startTime = new Date(startTime)
        startTime.setHours(0, 0, 0)
        startTime = new Date(startTime.getTime() - (startTime.getTimezoneOffset() * 60000))
        console.log('startTime::', startTime)
        console.log('fromDt::', this.fromDt)
      }

      let endTime = ''
      if (this.toDt) {
        endTime = Date.UTC(this.toDt.split('-')[0], this.toDt.split('-')[1] - 1, this.toDt.split('-')[2])
        endTime = new Date(endTime)
        endTime.setHours(23, 59, 59, 999)
        endTime = new Date(endTime.getTime() - (endTime.getTimezoneOffset() * 60000))
      }

      return { startTime, endTime }
    },
    generateQueryParams (startTime, endTime, campaignType, withLimitOffset, resetLimitOffset) {
      let queryParams = {
        searchText: (this.searchOpportunity || '').replace(/'/g, "''"),
        fromDt: startTime,
        toDt: endTime,
        countries: this.countries.map(ele => ele.toLowerCase())
      }
      let instanceCount = 2
      if (this.countries.length > 0) {
        const lowerCountries = this.countries.map(ele => ele.toLowerCase())
        if (instanceCountriesMapping['dashboard.mynivi.ke'].countries.some(r => lowerCountries.indexOf(r) >= 0)) instanceCount++
        if (instanceCountriesMapping['dashboard.mynivi.in'].countries.some(r => lowerCountries.indexOf(r) >= 0)) instanceCount++
      }
      if (campaignType === 'is') {
        queryParams = {
          ...queryParams,
          sort: this.isTableQueryParam.sort,
          oeType: true
        }
        if (withLimitOffset) {
          if (resetLimitOffset) {
            this.isTableQueryParam.limit = 10
            this.isTableQueryParam.page = 1
          }
          queryParams = {
            ...queryParams,
            offset: (instanceCount === 2 ? this.isTableQueryParam.limit / 2 : this.isTableQueryParam.limit) * (this.isTableQueryParam.page - 1),
            limit: instanceCount === 2 ? this.isTableQueryParam.limit / 2 : this.isTableQueryParam.limit
          }
        }
      } else {
        queryParams = {
          ...queryParams,
          sort: this.oosTableQueryParam.sort,
          oeType: false
        }
        if (withLimitOffset) {
          if (resetLimitOffset) {
            this.oosTableQueryParam.limit = 10
            this.oosTableQueryParam.page = 1
          }
          queryParams = {
            ...queryParams,
            offset: (instanceCount === 2 ? this.isTableQueryParam.limit / 2 : this.oosTableQueryParam.limit) * (this.oosTableQueryParam.page - 1),
            limit: instanceCount === 2 ? this.oosTableQueryParam.limit / 2 : this.isTableQueryParam.limit
          }
        }
      }

      return queryParams
    },
    getDbMReport (queryParams, campaignType) {
      return new Promise(resolve => {
        api.buildRequest('getDbMReport', 'POST', queryParams)
            .then(response => {
              if (response.status === 200) {
                this.inSessionCampaignsCount = response.data.payload.campaignTotals.inSessionTotal
                this.outOfSessionCampaignsCount = response.data.payload.campaignTotals.outOfSessionTotal
                if (campaignType === 'is') {
                  if (response.data.payload.inSessionCampaigns.opportunityList.length > 0) {
                    const resp = response.data.payload.inSessionCampaigns.opportunityList
                    this.inSessionCampaignsList = this.parseResponse(resp)
                    console.log('Processing IS API resonse::', this.inSessionCampaignsList.length)
                  } else {
                    this.inSessionCampaignsList = []
                  }
                } else {
                  if (response.data.payload.outOfSessionCampaigns.opportunityList.length > 0) {
                    const resp = response.data.payload.outOfSessionCampaigns.opportunityList
                    this.outOfSessionCampaignsList = this.parseResponse(resp)
                    console.log('Processing OOS API resonse::', this.outOfSessionCampaignsList.length)
                  } else {
                    this.outOfSessionCampaignsList = []
                  }
                }
              } else {
                console.log('something went wrong')
              }
              this.loading = false
              resolve(true)
            }).catch(({ response }) => {
              this.loading = false
              resolve(true)
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      })
    },
    parseResponse (resp) {
      const keys = Object.keys(resp[0])
      return resp.map(ele => {
        ele.children = ele.group_list
        ele.children = ele.children.map(child => {
          let obj = Object.assign(this.getEmptyObject(keys), child)
          let responses = obj['responded_to_options'] ? obj['responded_to_options'] : []
          if (responses.length > 0) {
            let str = ''
            responses.forEach(ele => {
              str += ele + ', '
            })
            const lastIndex = str.lastIndexOf(',')
            str = str.substring(0, lastIndex)
            obj['responded_to_options'] = str
          } else {
            obj['responded_to_options'] = '-'
          }
          return obj
        })
        delete ele['group_list']
        return ele
      })
    },
    handleColumnVisibilityToggle () {
      if (this.activeTab === 'is') this.inSessionCampaignColumns = [...this.generateInSessionCampaignColumns()]
      else this.outOfSessionCampaignColumns = [...this.generateOutOfSessionCampaignColumns()]
    },
    generateInSessionCampaignColumns () {
      const columns = [...startBaseInfoColumns, ...thresholdColumns, ...groupsSplitColumns,
        ...pokesColumns, ...responseColumns
      ]
      if (this.visibleColumnsIS['Referral Column Group']) columns.push(...referralColumns)
      columns.push(...endBaseInfoColumns)
      return columns
    },
    generateOutOfSessionCampaignColumns () {
      const columns = [...startBaseInfoColumns, ...goalColumns, ...thresholdColumns, ...groupsSplitColumns,
        ...nudgeColumns, ...responseColumns]
      if (this.visibleColumnsOOS['Referral Column Group']) columns.push(...referralColumns)
      if (this.visibleColumnsOOS['Cost Column Group']) columns.push(...costColumns)
      columns.push(...endBaseInfoColumns)
      return columns
    },
    generateCSVData (listClone) {
      let data = []
      listClone.forEach(campaign => {
        data.push({
          ...campaign,
          price: formatCost(campaign['price']),
          price_per_referral: formatCost(campaign['price_per_referral']),
          price_per_redemption: formatCost(campaign['price_per_redemption'])
        })
        if (campaign.children && campaign.children.length > 0) {
          campaign.children.forEach(group => {
            const campaignClone = {
              ...campaign,
              price: formatCost(campaign['price']),
              price_per_referral: formatCost(campaign['price_per_referral']),
              price_per_redemption: formatCost(campaign['price_per_redemption'])
            }
            const groupClone = {
              ...group,
              price: formatCost(group['price']),
              price_per_referral: formatCost(group['price_per_referral']),
              price_per_redemption: formatCost(group['price_per_redemption'])
            }
            data.push(Object.assign(campaignClone, groupClone))
          })
        }
      })
      return data
    },
    exportCSV () {
      let fields = []
      let columns = []
      let csvData = []
      const suffix = this.activeTab === 'is' ? '-In-Session' : '-Out-Of-Session'
      if (this.activeTab === 'is') {
        fields = this.inSessionCampaignColumns.map(ele => ele.field)
        columns = this.inSessionCampaignColumns.map(ele => ele.label)
        let listClone = [...this.inSessionCampaignsList]
        let data = this.generateCSVData(listClone)
        csvData = {fields, data}
      } else {
        fields = this.outOfSessionCampaignColumns.map(ele => ele.field)
        columns = this.outOfSessionCampaignColumns.map(ele => ele.label)
        let listClone = [...this.outOfSessionCampaignsList]
        let data = this.generateCSVData(listClone)
        csvData = {fields, data}
      }
      downloadCSVCustomColumns(csvData, columns, `DbMReport${suffix}`)
    }
  }
}
</script>
<style scoped>
.search-opportunity {
  margin-top: 0px;
  margin-left: 0px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.searchBox {
  width: 250px;
  margin-right: 20px;
  position: relative;
  cursor: default;
  top: 0px!important;
  left: 0px;
}
.margin-lr-20px {
  margin-left: 20px;
  margin-right: 20px; 
}
.margin-ltr-20px {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px; 
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
.export-container {
  display: flex;
  justify-content: space-between;
  align-items: center; 
  margin: 10px;
  margin-top: 15px;;
}
.column-groups-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center; 
  flex-wrap: wrap;
  margin-top: 5px;
  margin-bottom: 10px;
}
.column-group {
  margin-left: 5px;
  margin-right: 5px;
}
.filter-container {
  display: flex;
  justify-content: flex-end;
  align-items: center; 
  flex-wrap: wrap;
}
.table-container {
  display: block;
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
}
.vgt-wrap {
  position: relative;
  display: inline-block;
}
.empty-report {
  height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.table-container .vgt-left-align {
  text-align: left !important;
}
.table-container .vgt-pull-left {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// databaseMarketingReport.vue?a8dbb54c